import React, { Component } from "react";
import PropTypes from "prop-types";

import { Card, Form, Button, Input, message } from "antd";
import { connect } from "react-redux";

import storageUtils from "../../utils/storageUtils";
import { req_edit_tqa_b06, req_edit_tqa_c16, req_add_tqa_log } from "../../api";

const Item = Form.Item;

class VetoDescriptionModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    manual: PropTypes.object,
  };

  state = {};

  constructor(props) {
    super(props);

    this.get_files = React.createRef();
    this.editor = React.createRef();
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {}

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item_school = async (item) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_edit_tqa_b06(item, token);
    this.setState({ loading: false });
    if (result.status === "success") {
      message.success("退件成功");
    } else {
      message.error(result.message);
    }
  };

  api_modify_item_department = async (item) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_edit_tqa_c16(item, token);
    this.setState({ loading: false });
    if (result.status === "success") {
      message.success("退件成功");
    } else {
      message.error(result.message);
    }
  };

  api_add_log = async (item) => {
    const { token } = this.props.user;
    await req_add_tqa_log(item, token);
  };

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    // console.log("this.props.manual", this.props.manual);
  };

  // 操作互動處理 //////////////////////////////////////////////

  onFinish = (values) => {
    // console.log("Description:", values);
    console.log("Item:", this.props.manual);
    const { RecordDescription } = values;
    const {
      AcademicYear,
      WorkGuid,
      DepartmentCode,
      DepartmentName,
      DepartmentHeadId,
      DepartmentHeadName,
      DeanId,
      DeanName,
      WorkManualVersion,
      WorkTypeCode,
    } = this.props.manual;
    const manual = {
      RecordVersion: WorkManualVersion,
      RecordStatus: "VETO",
      RecordEditor: storageUtils.getUser().userCode,
      condition: "VETO",
      WorkTypeCode: WorkTypeCode,
    };
    var log = {};
    switch (WorkTypeCode) {
      case "A":
      case "B":
        this.api_modify_item_school(manual);
        log = {
          LogUid: WorkGuid,
          RecordType: "MAIN",
          DepartmentCode: DepartmentCode,
          RecordDescription:
            AcademicYear +
            "學年度-" +
            DepartmentName +
            DeanName +
            "，針對版號：" +
            WorkManualVersion +
            "，退件說明：" +
            RecordDescription,
          RecordCreator: DeanId,
        };
        this.api_add_log(log);
        break;
      case "C":
      case "D":
        this.api_modify_item_department(manual);
        log = {
          LogUid: WorkGuid,
          RecordType: "MAIN",
          DepartmentCode: DepartmentCode,
          RecordDescription:
            AcademicYear +
            "學年度-" +
            DepartmentName +
            DepartmentHeadName +
            "，針對版號：" +
            WorkManualVersion +
            "，退件說明：" +
            RecordDescription,
          RecordCreator: DepartmentHeadId,
        };
        this.api_add_log(log);
        break;
      default:
        break;
    }
  };

  ///////////////////////////////////////////////////////////

  render() {
    return (
      <Card>
        <Form onFinish={this.onFinish} onFinishFailed={this.onFinishFailed}>
          <Item
            label="說明"
            name="RecordDescription"
            initialValue={"內容須修訂，請重送"}
          >
            <Input.TextArea />
          </Item>
          <Item>
            <Button type="primary" htmlType="submit" block>
              送出
            </Button>
          </Item>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(VetoDescriptionModal);
